function normalize(str: string) {
    return str?.normalize?.("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() || '';
}

function levenshtein(a: string, b: string) {
    const dp = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
    for (let i = 0; i <= a.length; i++) dp[i][0] = i;
    for (let j = 0; j <= b.length; j++) dp[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            dp[i][j] = Math.min(
                dp[i - 1][j] + 1,
                dp[i][j - 1] + 1,
                dp[i - 1][j - 1] + cost
            );
        }
    }
    return dp[a.length][b.length];
}

function fuzzyIncludes(text: string, word: string) {
    const tokens = text?.split(/\s+/) || [];
    return tokens?.some(token => token?.includes(word) || levenshtein(token || '', word || '') <= 1) || false;
}

export function matchItems(items: string[], query: string) {
    const words = normalize(query)?.split(/\s+/) || [];
    return items?.filter((item: string) => {
        const normItem = normalize(item);
        return words?.every(word => fuzzyIncludes(normItem, word)) || false;
    }) || [];
}